import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="modal"
export default class extends Controller {
  static targets = ['container']

  connect() {
  }

  open(event) {
    event.preventDefault()
    this.containerTarget.classList.remove('hidden')
  }

  close(event) {
    event.preventDefault()
    this.containerTarget.classList.add('hidden')
  }
}
